import { sortBy } from 'lodash-es'
import { Account, AccountStatus } from '@ally/data-types-afg-accounts'
import { isAccountBlocked } from '../../utils'

const mortgageStatusWeightLookup = (account: Account): number => {
  // keep this above the ACTIVE logic
  if (isAccountBlocked(account) || account.status === AccountStatus.PAIDOFF) {
    return 2
  }

  if (account.status === AccountStatus.ACTIVE) {
    return 1
  }

  return 3 // if somehow we haven't accounted for a status, then put it very last
}

/**
 * Using lodash, sorts accounts by status and then accountNumber.
 */
export function sortByStatusAndAccountNumber(accounts: Account[]): Account[] {
  return sortBy(accounts, [
    (account): number => mortgageStatusWeightLookup(account),
    (account): number => parseInt(account.accountNumber, 10),
  ])
}
